import { render, staticRenderFns } from "./RuleActionShowText.vue?vue&type=template&id=4cdc82a4"
import script from "./RuleActionShowText.vue?vue&type=script&lang=js"
export * from "./RuleActionShowText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports